webpackJsonp([25840785411742],{

/***/ 1201:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"htmlAst":{"type":"root","children":[{"type":"element","tagName":"h2","properties":{},"children":[{"type":"text","value":"Uitleg"}]},{"type":"text","value":"\n"},{"type":"element","tagName":"p","properties":{},"children":[{"type":"text","value":"De "},{"type":"element","tagName":"strong","properties":{},"children":[{"type":"text","value":"comparativus"}]},{"type":"text","value":" komt overeen met de "},{"type":"element","tagName":"a","properties":{"href":"18a"},"children":[{"type":"element","tagName":"em","properties":{},"children":[{"type":"text","value":"vergelijkende trap"}]}]},{"type":"text","value":", bijvoorbeeld ‘groter’."}]}],"data":{"quirksMode":false}},"frontmatter":{"book":"spqr","leerdoel":"18b","title":"Leerdoel 18b"}}},"pathContext":{"slug":"/spqr/leerdoelen/18b/","title":"Leerdoel 18b"}}

/***/ })

});


// WEBPACK FOOTER //
// path---spqr-leerdoelen-18-b-75938c9b752966d7064e.js